import 'react-international-phone/style.css';
import Modal from "react-bootstrap/Modal";
import "./index.css";
import RequestQuoteForm from "../forms/RequestQuoteForm";

const RequestQuote = (props) => {
	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header>
				<h3 className="mb-0">Compare courier rates</h3>
				<button onClick={props.onHide} className="btn btn-sm close ms-auto">
					×
				</button>
			</Modal.Header>
			<Modal.Body className="">
				<RequestQuoteForm onHide={props.onHide} />
			</Modal.Body>
		</Modal>
	);
};

export default RequestQuote;
